
import { copyToClip } from '~/utils/index'

export default {
	props: {
		info: {
			type: Object,
			require: true
		},
		/**
		 * 跳转链接
		 */
		url: {
			type: String,
			default: ''
		},
		/**
		 * 新页面打开链接
		 */
		target: {
			type: Boolean,
			default: true
		},
		/**
		 * 是否显示图片
		 */
		showCover: {
			type: Boolean,
			default: true
		},
		/**
		 * 是否显示价格
		 */
		showPrice: {
			type: Boolean,
			default: true
		},
		/**
		 * 是否可复制商品编号
		 */
		isGoodNoCopy: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onCopy() {
			this.info.goodsNo && copyToClip(this.info.goodsNo, '已复制')
		}
	}
}
